<div class="collapsable-panel-dark collapsable-panel-dark-spacy">
  <div class="collapsable-panel-header">
    <button id="{{aid}}" type="button" class="panel-header-button btn w-100" (click)="toggle()" [attr.aria-expanded]="!isCollapsed">
      <span class="float-start icon far panel-icon" [ngClass]="faIconClass"></span>
      @if (isWarning) {
        <span class="float-start panel-header-content" ngbTooltip="{{warning}}"><i class="far fa-fw fa-exclamation-triangle panel-icon"></i></span>
      }
      <span class="float-start" translate="{{header}}"></span>
      <span class="float-start badge badge-pill badge-primary">{{badge}}</span>
      @if (showLoader) {
        <rask-busy-spinner class="float-start loader" size="1"></rask-busy-spinner>
      }
      <span class="float-end collapse-block-trigger-icon"><i class="far fa-chevron-down" [ngClass]="{'collapsable-panel-collapsed': !isCollapsed}"></i></span>
    </button>
  </div>
  <div class="collapsable-panel-body p-3" [ngbCollapse]="isCollapsed">
    <ng-content></ng-content>
  </div>
</div>
